import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastController, ViewController } from 'ionic-angular';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { PriceListTableProvider } from '../../providers/price-list-table/price-list-table';

@Component({
  selector: 'add-client-details',
  templateUrl: 'add-client-details.html'
})
export class AddClientDetailsComponent {
  
  form: FormGroup = new FormGroup({});
  constructor(public dataService: DataServiceProvider ,public priceListTableService: PriceListTableProvider,public toastController: ToastController,private configApiService: ConfigApiServiceProvider,private fb: FormBuilder,private viewCtrl: ViewController) {
    this.form = new FormGroup({
      addClient: this.fb.group({
        "email_Id": new FormControl('', Validators.email),
        "salutation": new FormControl(''),
        "client_Code": new FormControl('',Validators.required),
        "phone": new FormControl(''),
        "company_Name": new FormControl('',Validators.required),
        "address": new FormControl(''),
        "first_Name": new FormControl(''),
        "last_Name": new FormControl(''),
        "city": new FormControl(''),
        "province": new FormControl(''),
        "postal": new FormControl(''),
      })
    });
  }

  get f() {
    return this.form.controls.addClient['controls']
  }
  ngOnInit(){
}
  close(){
    this.viewCtrl.dismiss({
    });
  }
  onSubmit(){
    if(this.form.valid){
      let obj = {
        "clientCode": this.form.value.addClient['client_Code'],
        "companyName": this.form.value.addClient['company_Name'],
        "salutation": this.form.value.addClient['salutation'],
        "firstName": this.form.value.addClient['first_Name'],
        "lastName": this.form.value.addClient['last_Name'],
        "address": this.form.value.addClient['address'],
        "city": this.form.value.addClient['city'],
        "province": this.form.value.addClient['province'],
        "postal": this.form.value.addClient['postal'],
        "phone": this.form.value.addClient['phone'],
        "emailID": this.form.value.addClient['email_Id'],
        "clientLogo": '',
        "userid": 3280,
        "rptname": "Client_Details_12281",
        "client": "starport1294",
        "status": "",
        "Tag": "",
        "Created_date": "",
        "Created_By": "",
        "Modified_By": "",
        "Modified_date": "",
      }
      let objData = { data: JSON.stringify(obj) }
      this.configApiService.saveContract(objData).subscribe(respdata => {
        if (respdata["_POST_AddMethodResult"].length > 0) {
          if (respdata["_POST_AddMethodResult"][0].Result !== "FAIL") {
            this.dataService.ProposalTable.mspForm.ClientCode = this.form.value.addClient['client_Code'];
            this.dataService.ProposalTable.mspForm.ClientCompanyName = this.form.value.addClient['company_Name'];
            this.dataService.ProposalTable.mspForm.ClientFullName = this.form.value.addClient['salutation'] + ' ' + this.form.value.addClient['first_Name'] + ' ' + this.form.value.addClient['last_Name'];
            this.dataService.ProposalTable.mspForm.ClientLastName = this.form.value.addClient['last_Name'];
            this.dataService.ProposalTable.mspForm.ClientSalutation = this.form.value.addClient['salutation'];
            this.dataService.ProposalTable.mspForm.ClientAddress = this.form.value.addClient['address'];
            this.dataService.ProposalTable.mspForm.ClientCity = this.form.value.addClient['city'];
            this.dataService.ProposalTable.mspForm.ClientProvince = this.form.value.addClient['province'];
            this.dataService.ProposalTable.mspForm.ClientPostal = this.form.value.addClient['postal'];
            this.dataService.broadcastInfo({ src: 'proposal-create', event: 'ClientDetails', status: true });
            const toast = this.toastController.create({
              message: 'Client Details are Added',
              duration: 1000,
            });
            toast.present();
            this.viewCtrl.dismiss({
            });
          }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/add-client-details/add-client-details.ts